import {
  IAppointment,
  IAppointmentDetail,
  IOfficialLoading,
} from "../../types/appointments/Appointment";
import {
  IPublishedAppointment,
  IPublishedAppointmentDetail,
} from "../../types/appointments/PublishedAppointment";
import AppointmentsApi from "../api/appointmentsApi";
import * as types from "./actionTypes";

import { AppointmentStatus } from "../../types/appointments/AppointmentStatus";
import { IVenue } from "../../types/venue/Venue";
import { GenericTransport } from "../api/baseApi";

function getPublishedAppointmentsStart() {
  return { type: types.APPOINTMENTS_GET_PUBLISHED_STARTED };
}

function getPublishedAppointmentsRejected(message: string) {
  return { type: types.APPOINTMENTS_GET_PUBLISHED_REJECTED, payload: message };
}

function getPublishedAppointmentsFulfilled(
  appointments: IPublishedAppointment<IPublishedAppointmentDetail>[],
  venues: IVenue[],
) {
  return {
    type: types.APPOINTMENTS_GET_PUBLISHED_FULFILLED,
    payload: { appointments, venues },
  };
}

function updateAppointmentStatusStart(appointmentId: string) {
  return { type: types.APPOINTMENTS_UPDATE_STATUS_STARTED };
}

function updateAppointmentStatusRejected(
  appointmentId: string,
  message: string,
) {
  return { type: types.APPOINTMENTS_UPDATE_STATUS_REJECTED, payload: message };
}

function updateAppointmentFulfilled(
  appointment: IAppointment<IAppointmentDetail>,
) {
  return {
    type: types.APPOINTMENTS_UPDATE_FULFILLED,
    payload: appointment,
  };
}

function addLoadingStart(appointmentId: string) {
  return { type: types.APPOINTMENTS_ADD_LOADING_STARTED };
}

function addLoadingRejected(appointmentId: string, message: string) {
  return { type: types.APPOINTMENTS_ADD_LOADING_REJECTED, payload: message };
}

function addLoadingFulfilled(appointment: IAppointment<IAppointmentDetail>) {
  return {
    type: types.APPOINTMENTS_ADD_LOADING_FULFILLED,
    payload: appointment,
  };
}

function getAppointmentsByPersonFulfilled(
  data: GenericTransport<IAppointment<IAppointmentDetail>[]>,
) {
  return {
    type: types.APPOINTMENTS_GET_BY_PERSON_FULFILLED,
    payload: data,
  };
}

function getActionableAppointmentsFulfilled(data: GenericTransport<undefined>) {
  return {
    type: types.APPOINTMENTS_GET_ACTIONABLE_FULFILLED,
    payload: data,
  };
}

export function getPublishedAppointments(): (
  dispatch: Function,
) => Promise<IPublishedAppointment<IPublishedAppointmentDetail>[]> {
  return (dispatch) => {
    dispatch(getPublishedAppointmentsStart());
    return AppointmentsApi.getPublishedAppointments()
      .then(({ appointments, venues }) => {
        dispatch(getPublishedAppointmentsFulfilled(appointments, venues));
        return appointments;
      })
      .catch((er) => {
        dispatch(getPublishedAppointmentsRejected(er.message));
        throw er;
      });
  };
}

export function updateAppointmentStatus(
  apId: string,
  status: AppointmentStatus,
  comment?: string,
): (dispatch: Function) => Promise<IAppointment<IAppointmentDetail>> {
  return (dispatch) => {
    dispatch(updateAppointmentStatusStart(apId));
    return AppointmentsApi.updateAppointmentStatus(apId, { status, comment })
      .then((appointment) => {
        dispatch(updateAppointmentFulfilled(appointment));
        return appointment;
      })
      .catch((er) => {
        const message = er.toString();
        dispatch(updateAppointmentStatusRejected(apId, message));
        throw er;
      });
  };
}

export function addLoading(
  apId: string,
  loading: IOfficialLoading,
): (dispatch: Function) => Promise<IAppointment<IAppointmentDetail>> {
  return (dispatch) => {
    dispatch(addLoadingStart(apId));
    const ap = AppointmentsApi.addAppointmentBonus(apId, loading)
      .then((appointment) => {
        dispatch(addLoadingFulfilled(appointment));
        return appointment;
      })
      .catch((er) => {
        dispatch(addLoadingRejected(apId, er.message));
        throw er;
      });
    return ap;
  };
}

export function getAppointmentsByPerson(
  personId: string,
): (dispatch: Function) => Promise<IAppointment<IAppointmentDetail>[]> {
  return (dispatch) =>
    AppointmentsApi.getAppointmentsByPerson(personId).then((data) => {
      dispatch(getAppointmentsByPersonFulfilled(data));
      return data.appointments;
    });
}

export function setPaysheetVisibilityStatus(appointmentId: string, setVisible: boolean) {
  return (dispatch: any) =>
    AppointmentsApi.setPaysheetVisibilityStatus(appointmentId, setVisible).then(
      (appointment) => {
        dispatch(updateAppointmentFulfilled(appointment));
      },
    );
}

export function getActionableAppointments(): (
  dispatch: Function,
) => Promise<GenericTransport<undefined>> {
  return (dispatch) => {
    dispatch(getPublishedAppointmentsStart());
    return AppointmentsApi.getActionableAppointments().then((data) => {
      dispatch(getActionableAppointmentsFulfilled(data));
      return data;
    });
  };
}
